import { combineReducers } from 'redux';
import loader from '../loader/reducer';
import dashboard from '../dashboard/reducer';

export default combineReducers({
    loader,
    dashboard
});
